// extracted by mini-css-extract-plugin
module.exports = {"search":"Search-module--search--29sQI","icon":"Search-module--icon--2v_Gx","input":"Search-module--input--3hj-G"};